import { pureFilters } from '@/lib/agreement/filters';
import { differenceInYears, parseISO } from 'date-fns';

export default {
	props: {
		agreementData: {
			type: Object,
			required: true,
		},
	},
	computed: {
		childrenNames() {
			return this.agreementData.children.map(pureFilters.preferredName);
		},
		childrenUnder18Names() {
			return (
				this.agreementData.children.filter(child => {
					const {birthdate} = child
					return differenceInYears(new Date(), parseISO(birthdate))  < 18;
				}).map(pureFilters.preferredName)
			);
		},
	},
};
